var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 0.9375C4.33594 0.9375 3.96094 1.07813 3.70313 1.35938C3.44531 1.64063 3.28125 1.99219 3.28125 2.34375V27.6562C3.28125 28.0078 3.42188 28.3828 3.70313 28.6406C3.98438 28.9219 4.33594 29.0625 4.6875 29.0625H25.3125C25.6641 29.0625 26.0391 28.9219 26.2969 28.6406C26.5781 28.3594 26.7188 28.0078 26.7188 27.6562V8.90625L18.75 0.9375H4.6875Z",
    fill: "#FF9061"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 8.90625H20.1562C19.8047 8.90625 19.4297 8.76562 19.1719 8.48438C18.8906 8.22656 18.75 7.85156 18.75 7.5V0.9375L26.7188 8.90625Z",
    fill: "#FFDCBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8805 14.6037C20.1296 14.8391 20.2612 15.1776 20.2612 15.6798C20.2612 16.1819 20.1296 16.5205 19.8805 16.7559C19.6147 17.0072 19.1642 17.194 18.4988 17.2906H8.6194C8.00117 17.2906 7.5 17.7538 7.5 18.3251V22.9655C7.5 23.5368 8.00117 24 8.6194 24C9.23763 24 9.73881 23.5368 9.73881 22.9655V19.3596H18.5821C18.6351 19.3596 18.688 19.3561 18.7404 19.3492C21.1316 19.0335 22.5 17.74 22.5 15.6798C22.5 13.6196 21.1316 12.3261 18.7404 12.0104C18.688 12.0035 18.6351 12 18.5821 12H8.6194C8.00117 12 7.5 12.4632 7.5 13.0345C7.5 13.6058 8.00117 14.069 8.6194 14.069H18.4988C19.1642 14.1656 19.6147 14.3524 19.8805 14.6037Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.882b8ba93883e57350957a36008cbb64.svg";
export { ForwardRef as ReactComponent };